
import {TEAM_MEMBER_INTERVIEW_REQUEST, TEAM_MEMBER_INTERVIEW_SUCCESS,TEAM_MEMBER_INTERVIEW_FAIL} from "../constants/AuthConstant"

const axios = require("axios");

export const Interview_ListAction = ({ status, pageNumber = 0, pageSize = 10, admin = 'false', jobPositionSendapi, searchValue, filterActive }) => {

  return function (dispatch) {
      dispatch({
        type: TEAM_MEMBER_INTERVIEW_REQUEST,
        payload: true,
      });

      let OPTION = {
        url: admin ? `${process.env.REACT_APP_API_PATH}/ebench/interview/get_all_interview?interviewStatus=${status}&pageNumber=${pageNumber}&pageSize=${pageSize}&interviewType=${filterActive}&jobPosition=${jobPositionSendapi}&search=${searchValue}` : `${process.env.REACT_APP_API_PATH}/ebench/interview/get_all_interview?interviewStatus=${status}&pageNumber=-1&pageSize=-1`,
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      };

      axios(OPTION)
        .then((res) => {
          dispatch(loadAllDetailsPre(res.data));
        })
        .catch((error) => {
          dispatch({
            type: TEAM_MEMBER_INTERVIEW_FAIL,
            payload: false,
            error: error,
            msg: "Failed to load the information",
          });
        });
    };
  };

  export const loadAllDetailsPre = (data) => {
    return {
      type: TEAM_MEMBER_INTERVIEW_SUCCESS,
      result: data,
      payload: false,
      msg: "SUCCESS",
    };
  };